import all from './all.svg';
import popular from './popular.svg';
import roulette from './roulette.svg';
import cardGames from './cardGames.svg';
import slotMachines from './slotMachines.svg';
import lotto from './lotto.svg';
import favorite from './favorite.svg';
import nuevo from './nuevo.svg';
import merryChristmas from './merryChristmas.svg';
import halloween from './halloween.svg';

export const icons = {
  all,
  popular,
  roulette,
  cardGames,
  slotMachines,
  lotto,
  favorite,
  nuevo,
  merryChristmas,
  halloween,
};
